import { BehaviorSubject } from "rxjs"

class ConfigService {
    constructor() {
        let networkFile = "./network.config.json";
        this.config$ = new BehaviorSubject(null);
        const userAgent = navigator.userAgent.toLowerCase();
        // are we using electron?
        if (userAgent.indexOf(' electron/') > -1) {
            const fs = window.require('fs');
            const configFile = JSON.parse(fs.readFileSync(networkFile, 'utf8'));
            this.config$.next(configFile);
        } else {
            fetch(networkFile)
                .then(response => response.json())
                .then(json => {
                    this.config$.next(json)
                });
        }
    }
}

export const configService = new ConfigService();